import React, { useState ,useRef,useImperativeHandle,forwardRef} from 'react'
import { Modal } from 'antd'
import { useHistory } from 'react-router-dom'
import { getCurrentUser} from '@/utils/storage'
 function ApproveModal(props,onRef) {
    const modalRef = useRef(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const history = useHistory()
    useImperativeHandle(onRef,()=>({
             showModal:()=>{
                setIsModalVisible(true);
          },
    }))
   const handleOk = ()=>{
    setIsModalVisible(false);
      const userInfo = getCurrentUser()
            let userTag = userInfo.user_type
            if(userTag == 2){//退役军人
            history.push('/entrance/personal/userInfo')
            }else if(userTag == 5){//招聘企业
            history.push('/entrance/recruitEnterprise/enterpriseInfo')
            }else if(userTag == 6){//培训机构用户
            history.push('/entrance/personal/mechanismInfoManage')
            }else if(userTag == 7){//金融机构用户
            history.push('/entrance/personal/mechanismInfoManage')
            }
            console.log('userInfouserInfouserInfo',userInfo.user_type);
   }
   const handleCancel = ()=>{
    setIsModalVisible(false);
   }
    return (
        <div>
           <Modal okText={'去认证'} ref = {modalRef} title="提示！" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <p>由于您还没有进行身份认证因此部分功能无法使用</p>
            </Modal>
        </div>
    )
}
export default forwardRef(ApproveModal)